import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import {IoSearchCircleOutline} from "react-icons/io5";
import {toast} from "react-toastify";
import API from "../../Services/API";
import {GiTwoCoins} from "react-icons/gi";
import {useNavigate} from "react-router-dom";
import {BsShop} from "react-icons/bs";


const currencyFormat = Intl.NumberFormat('en-US');

function SearchProducts() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(true);
    const [products, setProducts] = React.useState([]);
    const [term, setTerm] = React.useState('');

    React.useEffect(() => {
        const search = window.localStorage.getItem("searchTerm")
        setTerm(search);
        if (search && search.length > 2) {
            setIsLoaded(false);
            const params = {
                search: search
            }
            API.searchProducts(params)
                .then((response) => {

                    setProducts(response.data);
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
    }, []);

    const onSearch = (val) => {
        setTerm(val.target.value);

        if (val.target.value.length > 2) {
            setIsLoaded(false);
            const params = {
                search: val.target.value
            }
            API.searchProducts(params)
                .then((response) => {

                    setProducts(response.data);
                    setIsLoaded(true);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
        else {
            setProducts([]);
        }

    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header title='جستجوی کالا' hasBack={true}/>
            <section className="container-fluid  mt-3 py-5 rtl px-0 mx-0 ">
                <div className="row search-city mx-2">
                    <div className="col-12  border-secondary border-opacity-25">
                        <IoSearchCircleOutline className='text-secondary text-big-3'/>

                        <input
                            autoFocus
                            type="text" placeholder='جستجو در همه کالاها'
                            className='text-secondary text-small-1 pe-3 w-75 border-0 bg-transparent no-visible-border'
                            value={term}
                            onChange={(val) => onSearch(val)}
                        />
                    </div>
                </div>

                {
                    isLoaded && products.map(product => {
                            const price = product.price * (1 - (product.discount_percent / 100))
                            return (
                                <div className="row mx-2 product-search-card  mx-2 pt-2 px-0 " key={product.id}
                                     onClick={() => {
                                         window.localStorage.setItem("searchTerm", term);
                                         window.localStorage.setItem("fromSearch", 1);
                                         navigate(`/vendor/${product.vendor_id}`);
                                     }}
                                >
                                    <div className="col-3 border-bottom pb-3 ">
                                        <img src={product.cover_image} alt={product.name} className='product-img' />
                                    </div>
                                    <div className="col-9 fw-bolder text-muted border-bottom pb-3 ">

                                        {product.name}
                                        {product.price ?
                                            <div className='price-with-discount mt-3'>

                                                <GiTwoCoins className='ms-2 '/>
                                                {
                                                    product.discount_percent &&
                                                    <span
                                                        className='text-decoration-line-through fw-normal text-small-2 px-2 '>
                                                       {currencyFormat.format(product.price)}
                                                        &nbsp;
                                                        ریال
                                            </span>
                                                }
                                                {currencyFormat.format(price)}
                                                &nbsp;
                                                ریال
                                                &nbsp;

                                            </div> :
                                            <div className='text-small-2 text-muted'>
                                                <GiTwoCoins className='mx-2'/>
                                                توافقی
                                            </div>
                                        }
                                    </div>


                                    <div className="col-10 py-2 text-small-3 fw-bold text-muted "
                                    >
                                        <BsShop className='mx-2 text-secondary' />
                                        {product.vendor}
                                    </div>
                                    <div className="col-2 py-2 text-small-2 text-muted ">


                                        <img src={product.vendor_image} alt={product.vendor} className='product-img opacity-50 gray-img' />

                                    </div>


                                </div>
                            );
                        }
                    )
                }
            </section>
        </React.Fragment>
    );
}

export default SearchProducts;